module.exports = __webpack_public_path__ + "static/media/992010.60f7dd61.png";